import { render, staticRenderFns } from "./AnnouncementSlide.vue?vue&type=template&id=a384011c"
import script from "./AnnouncementSlide.vue?vue&type=script&lang=js"
export * from "./AnnouncementSlide.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementSlide.vue?vue&type=style&index=0&id=a384011c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports